<script>
import Vue from 'vue'

export default Vue.extend({
  template: `
        <span v-if="params.node && params.node.data && params.node.data.id">
            <b-button size="sm" variant="outline-secondary" @click="btnClickedHandler()">View</b-button>
        </span>
    `,
  methods: {
    btnClickedHandler () {
      if (!this.params.data || !this.params.data.meta_name) {
        alert('Please click "View" on an individual line item, not on a grouping.')
        return
      }
      this.params.showLedgerItem(null, this.params.data)
    }
  }
})
</script>


// WEBPACK FOOTER //
// src/components/Programs/BankRecon/ButtonCellRenderer.vue